module.exports = __webpack_public_path__ + "fonts/1001bda8-900d-48db-981a-eade9e19d721.8c2223f.woff2";